var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Shield component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconShield extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.9 23.7C11.6132 23.7 11.3263 23.6 11.0395 23.5C8.07544 22.3 5.58947 20.2 3.77281 17.5C1.95614 14.8 1 11.6 1 8.2V3.4C1 2.8 1.19123 2.2 1.6693 1.7C2.05175 1.3 2.62544 1 3.29474 1H20.5053C21.0789 1 21.6526 1.2 22.1307 1.7C22.5132 2.1 22.8 2.7 22.8 3.4V8.3C22.8 11.6 21.8439 14.8 20.0272 17.6C18.2105 20.3 15.7246 22.4 12.7605 23.6C12.4737 23.7 12.1868 23.7 11.9 23.7ZM3.29474 2.6C3.10351 2.6 2.81667 2.7 2.72105 2.9C2.52982 3 2.52982 3.2 2.52982 3.4V8.3C2.52982 11.3 3.39035 14.2 5.01579 16.7C6.64123 19.2 8.93596 21.1 11.6132 22.2C11.8044 22.3 11.9956 22.3 12.1868 22.2C14.864 21.1 17.1588 19.2 18.7842 16.7C20.4096 14.2 21.2702 11.3 21.2702 8.3V3.4C21.2702 3.2 21.1746 2.9 20.9833 2.8C20.7921 2.6 20.6009 2.5 20.4096 2.5H3.29474V2.6Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconShield.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconShield.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconShield.prototype, "size", void 0);
if (customElements.get('cat-icon-shield') === undefined) {
    customElements.define('cat-icon-shield', BlocksIconShield);
}
